import { Button, FormField, FormRow, InfoCard } from "@endya-conformite/ui-kit";
import Download from "@endya-conformite/ui-kit/src/assets/icons/download.svg?react";
import { useMe } from "@src/store/store.me";
import styles from "./EntrepriseVirementForm.module.scss";

export function VirementForm() {
  const { me } = useMe();

  if (!me) return null;

  return (
    <>
      <FormRow>
        <FormField>
          <h2>Paiement par virement</h2>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <InfoCard>
            Indiquez le numéro SIREN dans la référence du virement :{" "}
            <b>{me.entreprisePrincipale.siren}</b>
          </InfoCard>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <Button icon={<Download />} variant="text">
            <a
              href="https://endya-public.s3.eu-west-3.amazonaws.com/rib_endya.pdf"
              target="_blank"
              rel="noreferrer"
              download
              className={styles.downloadLink}
            >
              Télécharger le RIB
            </a>
          </Button>
        </FormField>
      </FormRow>
    </>
  );
}
